export const UseIntegralKeyEnum = {
  USE_ED: 'consume_integral'
}

export const IntegralColumn = [
  {
    key: 'effected_integral',
    label: '已生效'
  },
  {
    key: 'frozen_integral',
    label: '未生效'
  },
  {
    key: 'consume_integral',
    label: '已消耗'
  }
]

export const IntegralScreeColumnsTypeEnum = {
  DATE: 1, //日期
  INCOME_AND_EXPEND: 2, //收支
  STATUS: 3 //状态
}

export const FastDataEnum = {
  ALL: '',
  TODAY: 'today',
  YESTERDAY: 'yesterday',
  CUR_WEEK: 'curWeek',
  CUR_MONTH: 'curMonth',
  CUR_YEAR: 'curYear'
}

export const IntegralFastDateColumns = [
  {
    text: '全部时间',
    value: FastDataEnum.ALL
  },
  {
    text: '今天',
    value: FastDataEnum.TODAY
  },
  {
    text: '昨天',
    value: FastDataEnum.YESTERDAY
  },
  {
    text: '本周',
    value: FastDataEnum.CUR_WEEK
  },
  {
    text: '本月',
    value: FastDataEnum.CUR_MONTH
  },
  {
    text: '今年',
    value: FastDataEnum.CUR_YEAR
  }
]

export const IncomeAndExpendTypeEnum = {
  ALL: 0,
  GET: 1,
  EXPEND: 2
}

export const IntegralIncomeAndExpendColumns = [
  {
    text: '全部收支',
    value: IncomeAndExpendTypeEnum.ALL
  },
  {
    text: '获取',
    value: IncomeAndExpendTypeEnum.GET
  },
  {
    text: '消耗',
    value: IncomeAndExpendTypeEnum.EXPEND
  }
]

export const IntegralStatusEnum = {
  ALL: 0,
  NOT_EFFECT: 2, //未生效
  HAS_EFFECT: 1, //已生效
  WAIT_CHECK: 3, //待审核
  HAS_SUCCESS: 4, //已成功
  HAS_REFUSE: 5, //已拒绝
  RECHARGE_BACK: 6, //充值回退
  ORDER_SUCCESS: 7, //订单成功
  ORDER_CANCEL: 8, //订单取消
  CANCEL_ORDER_BACK: 9 //订单回退
}

export const IntegralStatusColumns = [
  {
    text: '全部状态',
    value: IntegralStatusEnum.ALL
  },
  {
    text: '未生效',
    value: IntegralStatusEnum.NOT_EFFECT
  },
  {
    text: '已生效',
    value: IntegralStatusEnum.HAS_EFFECT
  },
  {
    text: '待审核',
    value: IntegralStatusEnum.WAIT_CHECK
  },
  {
    text: '审核失败',
    value: IntegralStatusEnum.HAS_REFUSE
  },
  {
    text: '审核成功',
    value: IntegralStatusEnum.HAS_SUCCESS
  },
  {
    text: '充值回退',
    value: IntegralStatusEnum.RECHARGE_BACK
  },
  {
    text: '已成功',
    value: IntegralStatusEnum.ORDER_SUCCESS
  },
  {
    text: '已取消',
    value: IntegralStatusEnum.ORDER_CANCEL
  },
  {
    text: '取消回退',
    value: IntegralStatusEnum.CANCEL_ORDER_BACK
  }
]
